export const secondsToTime = initial => {
  const hours = String(Math.floor(initial / (60 * 60)));

  const divisor_for_minutes = initial % (60 * 60);
  const minutes = String(Math.floor(divisor_for_minutes / 60));

  const divisor_for_seconds = divisor_for_minutes % 60;
  const seconds = String(Math.ceil(divisor_for_seconds));

  const obj = {
    h: hours.length === 1 ? `0${hours}` : hours,
    m: minutes.length === 1 ? `0${minutes}` : minutes,
    s: seconds.length === 1 ? `0${seconds}` : seconds
  };
  return obj;
};
